export default __webpack_public_path__ + "static/media/ic_menu_white_24px.12826de5.svg";